import React from 'react'
import { Box, RadioButton, Text } from '@usap/uicomponents'
import { Heading5 } from '../../../../common/heading'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import OptionsSelectItemsWMO from './OptionsSelectItemsWMO'

const OptionsSelectItems = props => {
  const {
    widgets,
    setCheckedSelected,
    appSteps,
    primaryStep,
    stepHandler,
    isDesktop,
    errorSteps,
    selectedPartETA,
    selectedPart,
    optionsToHide
  } = props

  const isWmoEnabled = useWmoEnabled()

  // Halt rendering when warranty claim already selects an option
  if (appSteps.length > 0 && primaryStep === 'warrantyClaim') {
    return null
  }

  const requiredData = widgets.required
    ? ''
    : '<em style="font-size: 12px;font-weight: normal">(Optional)</em>'

  const headerText = `${widgets.title} ${requiredData}`
  const currDate = new Date()
  const currDays = currDate.getDate()
  const currMonth = currDate.getMonth() + 1
  const currYear = currDate.getFullYear()
  const todaysDate = `${currYear}-${currMonth}-${currDays}`
  const isPassedDate = new Date(selectedPartETA) >= new Date(todaysDate)
  const isMainReason = widgets.id === 'mainReason'

  if (isPassedDate && isMainReason) {
    let indexLoc = 0
    widgets.options.forEach(item => {
      if (item.id === 'lateDelivery') {
        widgets.options.splice(indexLoc, 1)
      }
      indexLoc += 1
    })
  }
  const displayMainBox = optionsToHide.includes(widgets.id) ? 'none' : 'flex'

  if(isWmoEnabled) {
    return (<OptionsSelectItemsWMO {...props} />)
  }

  return (
    <>
      <Box id={widgets.id} style={{ display: displayMainBox }} margin={{ bottom: '24px' }}>
        <Heading5
          width="large"
          key={widgets.id}
          title={headerText}
          size={isDesktop ? 'medium' : 'small'}
          color="#000"
          style={{
            fontSize: '14px',
            fontWeight: 700,
            maxWidth: '100%',
          }}
          margin={{ bottom: '8px', top: '15px' }}
        />

        {widgets.subtitle && (
          <Box alignContent="start" alignSelf="start">
            <Text size="small" margin={{ left: 'xsmall' }}>
              {widgets.subtitle}
            </Text>
          </Box>
        )}

        <Text id={`error-${widgets.id}`} style={{ color: '#f90000', fontSize: '12px' }}>
          {errorSteps[widgets.id]}
        </Text>

        <Box
          direction="column"
          alignContent="start"
          alignSelf="start"
          margin="0"
          style={{ border: '1px solid #E0E0E0', borderRadius: '6px' }}
        >
          {widgets.options.filter(step => step.id !== 'lifetimeReplacement').map(({ label, value }) => (
            <Box
              key={`${widgets.id}-${value}`}
              id={`${widgets.id}-${value}`}
              className={`${widgets.id}-options`}
              width="large"
              direction="row"
              alignContent="start"
              alignSelf="start"
              pad="medium"
              style={{ borderBottom: '1px solid #E0E0E0', display: optionsToHide.includes(`${widgets.id}-${value}`) ? 'none' : 'flex' }}
            >
              <Box width="30px" alignContent="start" alignSelf="center">
                <RadioButton
                  key={`${widgets.id}-${value}`}
                  value={value}
                  name={widgets.id}
                  id={value}
                  style={{ minWidth: 'unset' }}
                  checked={setCheckedSelected(value)}
                  onClick={() => stepHandler(widgets, value, label, selectedPart)}
                />
              </Box>
              <Box
                width="100%"
                alignContent="start"
                alignSelf="start"
                onClick={() => stepHandler(widgets, value, label, selectedPart)}
              >
                <Text size="small" margin={{ left: 'xsmall' }} style={{ fontSize: '14px', fontWeight: 500 }}>
                  {label}
                </Text>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  )
}

export default OptionsSelectItems
